import React, { Fragment } from 'react';
import sad from '../../assets/images/other-images/sad.png';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="error-wrapper">
          <div className="container"><img className="img-100" src={sad} alt="sad" />
            <div className="error-heading">
              <h2 className="headline font-info">404</h2>
            </div>
              <p className="sub-content">A página que você está procurando não existe ou está temporariamente indisponível.</p>
            <div><Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-info-gradien">VOLTAR PARA PÁGINA INICIAL</Link></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Error404;